<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Verhuizen? Vergelijk gratis offertes!</h1>
      <p>
        Heeft u een verhuizing in het vooruitzicht en wilt u graag een
        professionele verhuisfirma inschakelen om uw spullen veilig naar uw
        nieuw adres te laten verhuizen? Dan biedt Verhuisvergelijker.be
        uitkomst. Hier heeft u de mogelijkheid om helemaal gratis offertes aan
        te vragen van verschillende verhuisfirma’s in uw eigen regio. Op die
        manier kunt u in alle rust de tarieven van de verhuisfirma’s naast
        elkaar leggen en beslissen met wie u in zee gaat. Verhuizen kan zo tot
        honderden euro’s goedkoper worden!
      </p>

      <h2>Hoe werkt het?</h2>
      <p>
        Het aanvragen van offertes via Verhuisvergelijker.be is helemaal
        kosteloos en binnen een mum van tijd gebeurd. Het enige wat u hoeft te
        doen is het invullen van uw gegevens, waarna wij op basis van uw
        postcode de aanvraag sturen naar de dichtstbijzijnde verhuisfirma’s in
        uw regio. Zij stellen naar aanleiding van uw aanvraag een offerte samen,
        die u binnen 24 uur ontvangt. U hoeft deze offertes alleen nog maar
        naast elkaar te leggen en bepaalt natuurlijk helemaal zelf door wie u uw
        spullen laat verhuizen. Zo voorkomt u dat u meteen een onnodig dure
        verhuisfirma kiest, terwijl u ergens anders veel voordeliger uit had
        kunnen zijn. Kortom: eerst vergelijken, daarna pas verhuizen!
      </p>

      <h2>Voordelig verhuizen?</h2>
      <p>
        Verhuizen is al duur genoeg, of het nu gaat om een particuliere
        verhuizing, zakelijke verhuizing of internationale verhuizing; elke
        mogelijkheid om te besparen op uw verhuizing is mooi meegenomen, vooral
        als het gaat om aanzienlijke bedragen. Maakt u het zichzelf niet
        moeilijker dan nodig is én bespaar vele euro’s door gratis offertes te
        vergelijken van verhuisfirma’s in uw omgeving. Vul vandaag nog uw
        gegevens in op Verhuisvergelijker.be en ontvang de volgende dag al
        meerdere offertes!
      </p>

      <h2>Regio's</h2>
      <ul>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/gent">
            Verhuizers in Gent
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/antwerpen">
            Verhuizers in Antwerpen
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/brussel">
            Verhuizers in Brussel
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/hasselt">
            Verhuizers in Hasselt
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/brugge">
            Verhuizers in Brugge
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/oostende">
            Verhuizers in Oostende
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/kortrijk">
            Verhuizers in Kortrijk
          </nuxt-link>
        </li>
        <li>
          <nuxt-link to="/informatie-over-verhuizers/aalst">
            Verhuizers in Aalst
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Informatie over verhuizers',
      headDescription:
        'Meer informatie over Verhuisvergelijker.be vindt u op deze informatie pagina.',
    }
  },
}
</script>
